module.exports = __webpack_public_path__ + "media/images/shapes/blurs/blur-2-efb02840fa14562e3c299d47711de7920a29b1d0685fb96163ec4240d1f26820.svg";